<p-dialog header="New Address" [(visible)]="visible" [modal]="true" appendTo="body" [style]="{width:'460px'}" (onHide)="close()" [closable]="true">
  <div class="formgrid grid">
    <div class="col-12 field">
      <p-floatLabel>
        <input id="street1" type="text" pInputText [(ngModel)]="workingAddress.street1" class="w-full" />
        <label for="street1">Street 1</label>
      </p-floatLabel>
    </div>
    <div class="col-12 field">
      <p-floatLabel>
        <input id="street2" type="text" pInputText [(ngModel)]="workingAddress.street2" class="w-full" />
        <label for="street2">Street 2</label>
      </p-floatLabel>
    </div>
    <div class="col-6 field">
      <p-floatLabel>
        <input id="city" type="text" pInputText [(ngModel)]="workingAddress.city" class="w-full" />
        <label for="city">City</label>
      </p-floatLabel>
    </div>
    <div class="col-3 field">
      <p-floatLabel>
        <input id="state" type="text" pInputText [(ngModel)]="workingAddress.state" class="w-full" />
        <label for="state">State</label>
      </p-floatLabel>
    </div>
    <div class="col-3 field">
      <p-floatLabel>
        <input id="zipCode" type="text" pInputText [(ngModel)]="workingAddress.zipCode" class="w-full" />
        <label for="zipCode">Zip Code</label>
      </p-floatLabel>
    </div>
  </div>
  <p-footer>
    <p-button label="Cancel" icon="pi pi-times" class="p-button-text" (onClick)="onCancel()"></p-button>
    <p-button label="Save" icon="pi pi-check" (onClick)="onSave()"></p-button>
  </p-footer>
</p-dialog>
